<ll-titulo>{{ "puntaje_core.carreras.buscador_carreras.titulo" | t }}</ll-titulo>

<buscador-carreras [withPais]="true"></buscador-carreras>
<carreras-terminos-modal></carreras-terminos-modal>
